import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { QueryProvider } from "./components/providers/QueryProvider";
import { MotionConfig } from "motion/react";
import { animationCurves } from "./utils/animationCurves";
import { HelmetProvider } from "react-helmet-async";
import { Router } from "./components/shared/Router";
import { ContentfulClientProvider } from "./components/providers/ContentfulClientProvider";
import { ThemeContextProvider } from "./components/providers/ThemeContextProvider";
import { GlobalContext, GlobalContextType } from "./utils/GlobalContext";
import { loadGoogleAnalytics } from "./utils/gTagLoader";
import { loadOneTrustConsent } from "./utils/oneTrustLoader";
import { i18n, initI18n, setDocumentLanguage } from "./services/i18n";

export const App = ({
  globalContext,
}: {
  globalContext: GlobalContextType;
}) => {
  const { region, environment, locale } = globalContext;

  useEffect(() => {
    void initI18n(locale);
  }, [locale]);

  useEffect(() => {
      loadGoogleAnalytics();
  }, [region]);

  useEffect(() => {
    loadOneTrustConsent(environment);
  }, [environment]);

  // Keep <html lang> in sync with the active locale (QC-015 / R-121).
  useEffect(() => {
    setDocumentLanguage(locale);
  }, [locale]);

  return (
    <GlobalContext.Provider value={globalContext}>
      <I18nextProvider i18n={i18n}>
        <QueryProvider>
          <HelmetProvider>
            <MotionConfig transition={animationCurves.default}>
              <ContentfulClientProvider>
                <ThemeContextProvider root>
                  <Router />
                </ThemeContextProvider>
              </ContentfulClientProvider>
            </MotionConfig>
          </HelmetProvider>
        </QueryProvider>
      </I18nextProvider>
    </GlobalContext.Provider>
  );
};
